// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p4Pl","colMin":"styles_colMin__3gQ5C"};